import { render } from "./PageRules.vue?vue&type=template&id=820a6624"
import script from "./PageRules.vue?vue&type=script&lang=js"
export * from "./PageRules.vue?vue&type=script&lang=js"

import "./PageRules.vue?vue&type=style&index=0&id=820a6624&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.9.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__